import { request } from '@/utils/request';

const urls = {
  associatedList: '/api/zlbuser/institution/relation/paging/associated', // 已关联的机构列表
  unassociatList: '/api/zlbuser/institution/relation/paging/associating', // 待关联的机构列表
  detail: '/api/zlbuser/institution/institution/detail', // 机构详情
  tobeAssociated: '/api/zlbuser/institution/relation/tobe/associated', // 新增关联
  cancelAssociated: '/api/zlbuser/institution/relation/cancel/associated', // 取消关联
};

export async function reqAssociatedList (data) {
  return request(urls.associatedList, { method: 'POST', data });
}

export async function reqUnassociatList (data) {
  return request(urls.unassociatList, { method: 'POST', data });
}

export async function reqDetail (params) {
  return request(urls.detail, { params });
}

export async function reqTobeAssociated (data) {
  return request(urls.tobeAssociated, { 
    method: 'POST',
    data, 
  });
}

export async function reqCancelAssociated (data) {
  return request(urls.cancelAssociated, { 
    method: 'POST',
    data, 
  });
}
